'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.default = Message;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _template = require('lodash/template');

var _template2 = _interopRequireDefault(_template);

var _templateSettings = require('lodash/templateSettings');

var _templateSettings2 = _interopRequireDefault(_templateSettings);

var _immutable = require('immutable/');

require('./message.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Inserts values to phrase under corresponding placeholders
 * Placeholders have forms like that: {showHelp__(2733)}, {recoverAccount}
 * @param {string} phrase Translated phrase eventually containing placeholders
 * @param {Object} params Placeholders to be inserted in phrase
 * @returns {string} Interpolated phrase
 */
var interpolateHrefs = function interpolateHrefs(phrase) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var interpolatedPhrase = phrase;
    (0, _keys2.default)(params).forEach(function (key) {
        interpolatedPhrase = interpolatedPhrase.replace(new RegExp('{' + key + '(__\\((.+)\\))?}', 'g'), params[key]('$2'));
    });
    return interpolatedPhrase;
};

/**
 * Message component
 * @param {MessagePropsType} props The properties object.
 * @returns {Element} React element
 * @constructor
 */

function Message(props) {
    _templateSettings2.default.interpolate = /{([\s\S]+?)}/g;

    var t = props.t,
        title = props.title,
        text = props.text,
        _props$placeholders = props.placeholders,
        placeholders = _props$placeholders === undefined ? new _immutable.Map() : _props$placeholders,
        className = props.className,
        accountRecoveryClicked = props.accountRecoveryClicked;


    var hrefPlaceholders = {
        showHelp: function showHelp(id) {
            return 'javascript:rn.showHelp(\'ANSWER\', ' + id + ');';
        },
        reopenAccount: function reopenAccount() {
            return '#';
        }, // this is not used yet
        ageVerification: function ageVerification() {
            return '#';
        }, // this is not used yet
        launchLiveChat: function launchLiveChat() {
            return '#';
        } // TODO:
    };

    var recoverAccountComponent = null;
    var placeholdersObj = placeholders.toJS();

    var titleTemplate = (0, _template2.default)(interpolateHrefs(t('login')(title), hrefPlaceholders));
    var titleString = titleTemplate(placeholdersObj);

    var textTemplate = (0, _template2.default)(interpolateHrefs(t('login')(text), hrefPlaceholders));
    var textString = textTemplate(placeholdersObj);

    if (textString.match('RecoverAccountComponent')) {
        var recoverAccountOpenTag = '<RecoverAccountComponent>';
        var recoverAccountCloseTag = '</RecoverAccountComponent>';
        var textTo = textString.indexOf(recoverAccountOpenTag);
        var textFrom = textString.indexOf(recoverAccountCloseTag);
        var firstPartText = textString.slice(0, textTo);
        var secondPartText = textString.slice(textFrom + recoverAccountCloseTag.length, textString.length);
        var translation = textString.slice(textTo + recoverAccountOpenTag.length, textFrom);

        recoverAccountComponent = (0, _jsx3.default)('div', {
            className: 'c-login-form__message-text'
        }, void 0, (0, _jsx3.default)('span', {}, void 0, firstPartText), (0, _jsx3.default)('span', {
            className: 'c-login-form__message-text__link',
            onClick: accountRecoveryClicked
        }, void 0, translation), (0, _jsx3.default)('span', {}, void 0, secondPartText));
    }

    return (0, _jsx3.default)('div', {
        className: className
    }, void 0, (0, _jsx3.default)('div', {
        className: 'c-login-form__message-title',
        dangerouslySetInnerHTML: { __html: titleString }
    }), recoverAccountComponent || (0, _jsx3.default)('div', {
        className: 'c-login-form__message-text',
        dangerouslySetInnerHTML: { __html: textString }
    }));
}
//# sourceMappingURL=message.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/login-component/dist/main/message/message.js
// module id = 498
// module chunks = 0